import { GdsStatCd } from '../model';

const REDIRECT_STATUS: ReadonlySet<GdsStatCd> = new Set<GdsStatCd>([
  'SH',
  'E',
  'A',
]);

/**
 * 품절(SH)·단종(E)·삭제(A) — 사이트맵에서 빠진 뒤에도 검색 유입이 남는 상태라 홈으로 보낸다 (SEO-338).
 * 판매보류(P)·판매대기(R)·임시저장(X1)은 정책상 제외 — 기존 안내 화면 유지.
 */
export const isRedirectableUnavailableGoods = (
  gdsStatCd?: GdsStatCd | null,
): boolean => !!gdsStatCd && REDIRECT_STATUS.has(gdsStatCd);
